import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "Club";
export const ClubService = {
	endpoint,
	getMy: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/My`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getFeatures: async () => await FetchInterceptor(`${environment.server.apiURL}/Club/Features`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	// Anonymous - fetch() directly so no auth/refresh interception on the login screen.
	getBranding: async (slug: string) => await fetch(`${environment.server.apiURL}/${endpoint}/Branding/${encodeURIComponent(slug)}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	updateSingleById: async (id: number, data: any) => await Service.updateSingleById(endpoint, id, data)
}
